/**
 * The pricing explainer, shared by the home page and the employer page.
 *
 * Every figure is read from the shared constants, so the copy can never drift
 * away from what the payment code actually charges.
 */

import type { ReactNode } from 'react';

import {
  LISTING_LIFETIME_DAYS,
  MINIMUM_FIRST_BID_CENTS,
  PASS_INCREMENT_CENTS,
} from '@bidtohire/shared';

import { Money } from '../components/Money';

export function PricingTrio(): ReactNode {
  return (
    <div className="card is-flat pricegrid">
      <div>
        <span className="eyebrow">Posting</span>
        <div className="title">
          From <Money cents={MINIMUM_FIRST_BID_CENTS} />
        </div>
        <p>
          One payment of <Money cents={MINIMUM_FIRST_BID_CENTS} /> or more reserves the listing and
          buys its position. Paste the posting afterwards and we fill in the details. A salary range
          is required.
        </p>
      </div>
      <div>
        <span className="eyebrow">Claiming a position</span>
        {/* Not a fee schedule. This is what passing a row means when dollars are
            the only denomination: a dollar more than it. Bid whatever you like
            above the floor and land where the money lands. */}
        <div className="title">
          Any row’s total{' '}
          <span className="mono">
            + <Money cents={PASS_INCREMENT_CENTS} />
          </span>
        </div>
        <p>
          Bid any amount from <Money cents={MINIMUM_FIRST_BID_CENTS} />. Rank is the total paid, and
          every listing shows the figure that would pass it. Matching a total does not take it — the
          earlier bid keeps the higher rank. Raising is a top-up: you pay the difference. Bids are
          non-refundable.
        </p>
      </div>
      <div>
        <span className="eyebrow">Listing term</span>
        <div className="title">{LISTING_LIFETIME_DAYS} days, renewable free</div>
        <p>
          Listings expire {LISTING_LIFETIME_DAYS} days after publishing. Renewal is free. The total
          paid and the position carry over.
        </p>
      </div>
    </div>
  );
}
